import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import PageItem from './PageItem'

const menuCss = css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
`

const PagesMenu = ({ items, ...rest }) => {
  return (
    <div css={menuCss} {...rest}>
      {items?.map((item) => (
        <PageItem key={item && (item.label || item.href)} {...item} />
      ))}
    </div>
  )
}

PagesMenu.propTypes = {
  items: PropTypes.array,
}

export default PagesMenu
